export const CURR_SONG_KEY = 'currSongPlaying';
export const CURR_TIME_KEY = 'currTimeSongPlaying';
export const PLAYER_VOLUME_MUTED_KEY = 'playerVolumeIsMuted';
export const PLAYER_VOLUME_KEY = 'playerVolume';
export const SONG_QUEUE_KEY = 'songQueue';
export const SONG_HISTORY_KEY = 'songHistory';

class LocalStorage {
    static setItem(key: string, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    static getItem<T>(key: string): T | null {
        const value = localStorage.getItem(key);
        if (value) {
            return JSON.parse(value);
        }
        return null;
    }
}

export default LocalStorage;
